import client from "./client";
import { fetchPublicQuery } from "../utils/publicQueryCache";

export const fetchCachedPublicGet = (path, options = {}) => {
  const requestOptions = { ...options };
  const cacheEnabled = requestOptions.cache !== false;
  const ttlMs = Number(requestOptions.cacheTtlMs) || 60_000;
  const maxStaleMs = Number(requestOptions.cacheMaxStaleMs) || undefined;
  const force = Boolean(requestOptions.force);
  const staleWhileRevalidate = requestOptions.staleWhileRevalidate !== false;
  const retainStaleOnError = requestOptions.retainStaleOnError !== false;
  delete requestOptions.cache;
  delete requestOptions.cacheTtlMs;
  delete requestOptions.cacheMaxStaleMs;
  delete requestOptions.force;
  delete requestOptions.staleWhileRevalidate;
  delete requestOptions.retainStaleOnError;

  if (force && !requestOptions.browserCache) {
    requestOptions.browserCache = "no-cache";
  }

  if (!cacheEnabled) return client.get(path, requestOptions);
  return fetchPublicQuery({
    key: path,
    ttlMs,
    maxStaleMs,
    force,
    staleWhileRevalidate,
    retainStaleOnError,
    load: () => client.get(path, requestOptions),
  });
};

export default fetchCachedPublicGet;
